<div class="container-fluid user-profile" *ngIf="loginDetails$ | async; let loginDetails">
    <div *ngIf="loginDetails.currentProfile">
        <app-optin
                [userProfile]="loginDetails.currentProfile"
        >
        </app-optin>
    </div>
</div>
